/**
 * Auction message constructors for transaction signing
 */

import type { BidRequest } from '@/types/auctions';
import type { EncodeObject } from '@cosmjs/proto-signing';

/**
 * Create a MsgBid for bidding on an auction
 * 
 * Reference: auction.v1.MsgBid from @chalabi/gravity-bridgejs
 */
export function createBidMsg(request: BidRequest): EncodeObject {
  return {
    typeUrl: '/auction.v1.MsgBid',
    value: {
      auctionId: BigInt(request.auction_id),
      bidder: request.bidder,
      amount: BigInt(request.bid_amount),
      bidFee: BigInt(request.bid_fee),
    },
  };
}

/**
 * Helper to convert whole tokens to micro units (e.g., GRAV to ugraviton)
 */
export function toMicroUnits(amount: string, decimals = 6): string {
  const num = parseFloat(amount);
  if (isNaN(num) || num < 0) {
    throw new Error('Invalid amount');
  }
  return Math.floor(num * Math.pow(10, decimals)).toString();
}

/**
 * Helper to convert micro units to whole tokens (e.g., ugraviton to GRAV)
 */
export function fromMicroUnits(amount: string, decimals = 6): string {
  const num = parseFloat(amount);
  if (isNaN(num)) {
    return '0';
  }
  return (num / Math.pow(10, decimals)).toFixed(decimals);
}

export const auctionMessages = {
  createBidMsg,
  toMicroUnits,
  fromMicroUnits,
};
